import { Platform, StyleSheet } from 'react-native';
import {
  green,
  fontSizeSmall,
  fontFamilyLight,
} from '../../../constants/palette';

const width = Platform.OS === 'web' ? 275 : '85%';

const styles = StyleSheet.create({
  buttonContainer: {
    // flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  backButton: {
    marginTop: 50,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width,
  },
  connectButton: {
    backgroundColor: green,
  },
  header: {
    marginBottom: 10,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
  signup: {
    fontSize: fontSizeSmall,
    fontFamily: fontFamilyLight,
    marginTop: 20,
    // marginBottom: 10,
  },
  title: {
    fontSize: 20,
    marginTop: 10,
    marginBottom: 20,
  },
  text: {
    marginTop: 10,
    marginBottom: 10,
    padding: 20,
    fontStyle: 'italic',
  },
});

export default styles;
